import { Vue, Component, Prop, Inject, Watch } from 'vue-property-decorator';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import { formatDateAgo } from '../../../util/date-util';
import moment from 'moment';
import { innitReportDetails } from '@/entities/report-insights/my-report.component';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { convertToBriefingResourceReq, getHostName } from '@/util/ds-util';
import { REFERENCE_STYLE_FOR } from '@/constants';
import ReferenceCardComponent from '@/shared/cards/references/reference-card.vue';
import ListLoading from '@/entities/resource-management/list-loading/list-loading.vue';

const appStoreState = namespace('appStore');

const briefingStore = namespace('briefingStore');

@Component({
  computed: {
    REFERENCE_STYLE_FOR() {
      return REFERENCE_STYLE_FOR;
    },
    moment() {
      return moment;
    },
  },
  methods: { formatDateAgo },
  components: {
    'reference-card-component': ReferenceCardComponent,
    'go-loading': ListLoading,
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class PopupEditReportRef extends Vue {
  @Prop() items: any[] | [];
  @Prop() arrDocId: any[] | any;
  @Prop() contentReference: any[] | any;

  @appStoreState.Getter
  public getIsShowEditReportRef!: boolean;

  @appStoreState.Mutation
  public setShowEditReportRef!: (newVal: boolean) => void;

  @appStoreState.Getter
  public isShowAddReference!: boolean;

  @appStoreState.Mutation
  public setShowAddReference!: (isShowAddReference: boolean) => void;

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @briefingStore.Getter
  getReferenceDocumentsForReport!: Array<any>;

  @briefingStore.Mutation
  public setReferenceDocumentsForReport!: (payload: any) => void;

  @briefingStore.Getter
  getStoreReferenceDocumentsForReport!: Array<any>;

  @briefingStore.Mutation
  public setStoreReferenceDocumentsForReport!: (payload: any) => void;

  @appStoreState.Getter
  public getIsOpenPopupEditReferenceForPage!: boolean;

  @appStoreState.Mutation
  public setIsOpenPopupEditReferenceForPage!: (payload: boolean) => void;

  @briefingStore.Getter
  getReferenceDocuments!: Array<any>;

  @briefingStore.Mutation
  public setReferenceDocuments!: (payload: any) => void;

  @briefingStore.Getter
  getStoreReferencesForEditByPage!: Array<any>;

  @briefingStore.Mutation
  public setStoreReferencesForEditByPage!: (payload: any[]) => void;

  @briefingStore.Action
  public removeFromReferenDocuments!: (payload: any) => void;

  @briefingStore.Getter
  public getSelectedBriefingPage!: any;

  @briefingStore.Mutation
  public addToReferentDocuments!: (docIds: any[]) => void;

  referentItems: any[] = [];
  startIndex = 0;
  endIndex = 0;
  dataBody = [];
  reportDetail: any = innitReportDetails;
  isLoadingSaveBriefingResource = false;
  userKey = JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
  originReferenceItems: any[] = [];
  scrollSettings = {
    wheelPropagation: false,
  };
  loading = false;

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;

  @Watch('arrDocId')
  onItemChange() {
    this.handleGetData();
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  created() {}

  mounted() {
    if (!this.userKey) {
      this.userKey = this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    }

    this.handleGetData();
  }

  @Watch('getReferenceDocumentsForReport')
  onGetReferenceDocumentsForReportChange() {
    this.modifyData(this.getReferenceDocumentsForReport);
  }

  @Watch('getReferenceDocuments')
  onGetReferenceDocumentsChange() {
    if (this.getIsOpenPopupEditReferenceForPage && this.getReferenceDocuments?.length > 0) {
      this.referentItems = this.getReferenceDocuments;
    }
  }

  @Watch('getStoreReferencesForEditByPage')
  onGetStoreReferencesForEditByPageChange() {
    this.modifyData(this.getStoreReferencesForEditByPage);
  }

  handleGetData() {
    if (this.getIsOpenPopupEditReferenceForPage) {
      if (!this.originReferenceItems || this.originReferenceItems?.length === 0) {
        this.originReferenceItems = [...this.getReferenceDocuments];
      }

      this.referentItems = this.getReferenceDocuments;

      return;
    }

    if (this.getStoreReferenceDocumentsForReport?.length > 0) {
      this.referentItems = this.getStoreReferenceDocumentsForReport;

      // return;
    } else {
      this.referentItems = [];
    }

    // comment because just need get all documents
    // if (this.arrDocId.length > 0) {
    //   const parentDocIds: any[] = this.arrDocId;
    //   this.discoveryService()
    //     .getRelatedReferent(parentDocIds)
    //     .then(res => {
    //       this.referentItems = res?.data?.body;
    //       this.originReferenceItems = res?.data?.body;
    //       // this.startIndex = 0;
    //       // this.endIndex = this.arrDocId.length;
    //     });
    // } else {
    //   // this.referentItems = [];
    //   // this.reportDetail = innitReportDetails;
    //   const parentDocIds: any[] = this.contentReference;
    //   this.discoveryService()
    //     .getRelatedReferent(parentDocIds)
    //     .then(res => {
    //       this.referentItems = res?.data?.body;
    //       this.originReferenceItems = res?.data?.body;
    //       // this.startIndex = 0;
    //       // this.endIndex = this.contentReference.length;
    //     });
    // }

    // take all reference
    // this.referentItems = [];
    // this.reportDetail = innitReportDetails;
    const parentDocIds: any[] = this.contentReference;
    this.loading = true;
    this.discoveryService()
      .getRelatedReferent(parentDocIds)
      .then(res => {
        if (this.getStoreReferenceDocumentsForReport?.length > 0) {
          this.referentItems = this.getStoreReferenceDocumentsForReport;
        } else {
          this.referentItems = res?.data?.body;
        }

        if (!this.originReferenceItems || this.originReferenceItems?.length === 0) {
          this.originReferenceItems = res?.data?.body;
        }

        // this.startIndex = 0;
        // this.endIndex = this.contentReference.length;
      })
      .finally(() => (this.loading = false));
  }

  handleCloseModel() {
    this.setShowEditReportRef(false);
    this.setIsOpenPopupEditReferenceForPage(false);
  }

  handleOpenPopupAddReferenceModal() {
    if (
      (!this.getSelectedResource ||
        !this.getSelectedResource?.owner_user_key ||
        this.getSelectedResource?.owner_user_key === undefined ||
        !this.userKey ||
        this.userKey === '' ||
        this.userKey !== this.getSelectedResource?.owner_user_key) &&
      !this.getIsOpenPopupEditReferenceForPage
    ) {
      return;
    }

    this.setShowAddReference(true);
  }

  handleDeleteReference(indexInput: number) {
    if (
      indexInput !== undefined &&
      indexInput >= 0 &&
      this.referentItems &&
      this.referentItems?.length > 0 &&
      indexInput < this.referentItems?.length
    ) {
      this.referentItems = this.referentItems.filter((_, index) => index !== indexInput);
    }
  }

  async saveReferenceDocuments() {
    // set data to modify reference report if confirm

    // state
    const tempList = [...this.referentItems];

    if (this.getIsOpenPopupEditReferenceForPage) {
      if (this.$route.name === 'Home') {
        this.setReferenceDocuments([...tempList]);
      } else if (this.$route.name === 'MyBriefing-Detail') {
        this.isLoadingSaveBriefingResource = true;

        // find deleted and added item
        const tempReferenceIds =
          this.getReferenceDocuments
            ?.map(referenceItem => referenceItem?.docId || referenceItem?.parentDocId || referenceItem?.doc_id || '')
            .filter(item => item !== undefined && item !== '') || [];

        const tempEditedReferenceIds =
          this.referentItems
            ?.map(item => item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id)
            .filter(item => item !== undefined && item !== '') || [];

        const deletedReferenceIds = tempReferenceIds?.filter(item => !tempEditedReferenceIds?.includes(item)) || [];

        const addedReferenceIds = tempEditedReferenceIds?.filter(item => !tempReferenceIds?.includes(item)) || [];
        const addedReferences = this.referentItems?.filter(item =>
          addedReferenceIds?.includes(item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id)
        );

        // call API to delete and add reference
        // delete references
        if (deletedReferenceIds?.length > 0) {
          await this.removeReferences(deletedReferenceIds);
        }

        // add references
        if (addedReferences?.length > 0) {
          await this.addToReference(addedReferences, deletedReferenceIds);
        }
      }
    } else {
      this.setStoreReferenceDocumentsForReport([...tempList]);
    }

    // API to DB: pending
    // todo

    // turn off modal
    this.setShowEditReportRef(false);
    this.setIsOpenPopupEditReferenceForPage(false);

    const button = document.getElementById('closeModalButton');

    if (button) {
      button.click();
    }
  }

  checkIfCanSaveReferenceDocuments(): boolean {
    if (!this.referentItems || !this.originReferenceItems || this.referentItems?.length === 0 || this.originReferenceItems?.length === 0) {
      return false;
    }

    // Check if the lengths are different
    if (this.referentItems.length !== this.originReferenceItems.length) {
      return true;
    }

    // Create arrays of IDs for comparison
    const modifyIdsList = this.referentItems.map(
      item => item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id
    );

    const originIdsList = this.originReferenceItems.map(
      item => item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id
    );

    // Check for any modifications in IDs
    const hasModifiedItems = modifyIdsList.some(id => !originIdsList.includes(id));

    return hasModifiedItems;
  }

  handleResetOriginReferenceDocuments() {
    if (this.getIsOpenPopupEditReferenceForPage) {
      this.referentItems = this.getReferenceDocuments || [];

      return;
    } else {
      this.setStoreReferenceDocumentsForReport([]);
      this.originReferenceItems = [];
      this.referentItems = [];

      setTimeout(() => {
        this.handleGetData();
      }, 10);
    }
  }

  modifyData(inputList: any[]) {
    if (inputList?.length > 0) {
      if (!this.getIsOpenPopupEditReferenceForPage) {
        let tempList = inputList.map(item => {
          return {
            id: item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id,
            data: item ? { ...item } : {},
          };
        });

        if (this.referentItems?.length > 0) {
          const tempIdsList = this.referentItems?.map(
            item => item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id
          );

          if (tempIdsList?.length > 0) {
            tempList = tempList.filter(item => !tempIdsList?.includes(item?.id) && item?.id && item.data);
          } else {
            tempList = tempList.filter(item => item?.id && item.data);
          }
        } else {
          tempList = tempList.filter(item => item?.id && item.data);
        }

        tempList = tempList.map(item => ({ ...item, isNew: true }));

        if (tempList && tempList.length > 0) {
          this.referentItems = [...tempList, ...this.referentItems];
        }
      } else {
        // console.log('inputList: ', inputList);
        let tempList = inputList.map(item => {
          return {
            ...item,
            id: item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id,
          };
        });

        if (this.referentItems?.length > 0) {
          const tempIdsList = this.referentItems?.map(
            item => item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id
          );

          if (tempIdsList?.length > 0) {
            // console.log('tempList: ', tempList);
            // console.log('tempIdsList: ', tempIdsList);
            // console.log('tempIdsList?.includes(item?.id): ', tempIdsList?.includes(item?.id));
            // tempList.forEach(item => {
            //   // console.log('!tempIdsList?.includes(item?.id) && item?.id: ', !tempIdsList?.includes(item?.id) && item?.id);
            // });
            tempList = tempList.filter(item => !tempIdsList?.includes(item?.id) && item?.id);
            // console.log('tempList: ', tempList);
          } else {
            tempList = tempList.filter(item => item?.id);
          }
        } else {
          tempList = tempList.filter(item => item?.id);
        }

        tempList = tempList.map(item => ({ ...item, isNew: true }));

        if (tempList && tempList.length > 0) {
          // console.log('tempList: ', tempList);
          // console.log('this.referentItems: ', this.referentItems);
          this.referentItems = [...this.referentItems, ...tempList];
        }
      }

      this.setReferenceDocumentsForReport([]);
      this.setStoreReferencesForEditByPage([]);
    }
  }

  async removeReferences(deletedReferenceIds: string[]) {
    if (deletedReferenceIds?.length > 0) {
      const bpId = this.getReferenceDocuments?.[0]?.bpId || this.getSelectedBriefingPage?.bpId || '';

      if (bpId?.length > 0) {
        await this.briefingService()
          .removeResourceDocument(bpId, [...deletedReferenceIds])
          .then(response => {
            if (response?.status && response?.status === 200) {
              this.removeFromReferenDocuments({ docIdsToRemove: [...deletedReferenceIds] });
            }
          })
          .catch(() => {
            this.isLoadingSaveBriefingResource = false;
          });
      } else {
        this.removeFromReferenDocuments({ docIdsToRemove: [...deletedReferenceIds] });
      }
    }
  }

  async addToReference(documents: any[], deletedReferenceIds: string[]) {
    if (!documents || documents?.length === 0) {
      this.isLoadingSaveBriefingResource = false;
      return;
    }

    let isUpdateBriefing = false;

    if (this.$route.name === 'Home') {
      const tempRequestedResourceList =
        documents
          ?.map(
            item => item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id
          )
          .filter(item => item !== undefined && item !== '') || [];

      documents = documents.map(document => {
        document.requestedResourceList = [...tempRequestedResourceList];
        return document;
      });

      isUpdateBriefing = false;
    } else {
      let tempRequestedResourceList = [...documents, ...this.getReferenceDocuments]
        ?.map(
          item => item?.docId || item?.parentDocId || item?.parent_doc_id?.[0] || item?.doc_id || item?.id || item?._id || item?.data?._id
        )
        ?.filter(id => id !== undefined && id !== '');

      if (deletedReferenceIds?.length > 0) {
        tempRequestedResourceList = tempRequestedResourceList.filter(item => !deletedReferenceIds.includes(item));
      }

      // console.log('tempRequestedResourceList: ', tempRequestedResourceList);

      documents = documents.map(document => {
        document['requestedResourceList'] = [...tempRequestedResourceList];
        return document;
      });

      isUpdateBriefing = true;
    }

    let briefingResources = documents.map(item =>
      convertToBriefingResourceReq(
        item,
        this.$store.getters.userIdentity.id,
        this.$route.name,
        this.$store.getters['briefingStore/getSelectedBriefingPage'],
        undefined,
        this.$i18n.locale,
        this.$store.getters?.userIdentity?.lastName,
        undefined,
        isUpdateBriefing
      )
    );

    let maxReferenceDocumentIndex = this.referentItems ? Math.max(...this.referentItems?.map(item => item.referenceDocumentIndex)) : 0 || 0;

    maxReferenceDocumentIndex = maxReferenceDocumentIndex > -1 ? maxReferenceDocumentIndex : 0;

    briefingResources = briefingResources.map((briefingResource, index) => {
      // @ts-ignore
      briefingResource.search_type = documents?.[index]?.originParentDocDetail?.search_type;
      // @ts-ignore
      briefingResource.mediaType = documents?.[index]?.originParentDocDetail?.media_type;

      if (
        (briefingResource?.search_type?.[0] === 'REPORT' && briefingResource?.mediaType?.[0] === 'REPORT') ||
        documents?.[index]?.originParentDocDetail?.doc_type === 4
      ) {
        briefingResource.originType = 'REPORT';
      } else {
        briefingResource.originType = 'DISCOVERY';
      }

      briefingResource.parentDocId =
        documents?.[index]?.docId ||
        documents?.[index]?.parentDocId ||
        documents?.[index]?.parent_doc_id?.[0] ||
        documents?.[index]?._id ||
        documents?.[index]?.id ||
        documents?.[index]?.doc_id;

      if (this.referentItems?.length) {
        briefingResource['referenceDocumentIndex'] = maxReferenceDocumentIndex + 1 + index;
      } else {
        briefingResource['referenceDocumentIndex'] = 1;
      }
      return briefingResource;
    });

    await this.briefingService()
      .saveBriefingResource([...briefingResources], true)
      .then(() => {
        briefingResources = briefingResources.map((briefingResource, index) => {
          briefingResource.published_at = documents?.[index]?.publishAt;
          briefingResource.originParentDocDetail = documents?.[index]?.originParentDocDetail;
          briefingResource.docId =
            documents?.[index]?.docId ||
            documents?.[index]?.parentDocId ||
            documents?.[index]?.parent_doc_id?.[0] ||
            documents?.[index]?._id ||
            documents?.[index]?.id ||
            documents?.[index]?.doc_id;
          briefingResource.isNew = true;

          return briefingResource;
        });

        this.addToReferentDocuments([...briefingResources]);
      })
      .catch(err => {
        const tempListRemoveIds = briefingResources.map(item => item?.parentDocId || item?.docId);

        this.removeFromReferenDocuments({ docIdsToRemove: [...tempListRemoveIds] });
      })
      .finally(() => {
        this.isLoadingSaveBriefingResource = false;
      });
  }

  getChanel(documentItem: any): string {
    let tempChannel = '';

    if (documentItem) {
      tempChannel = documentItem.channel
        ? documentItem.channel
        : documentItem.link
        ? getHostName(documentItem.link)
        : documentItem.url
        ? getHostName(documentItem.url)
        : documentItem.path
        ? getHostName(documentItem.path)
        : documentItem.sourceUriDomain
        ? getHostName(documentItem.sourceUriDomain)
        : documentItem.writer
        ? getHostName(documentItem.writer)
        : '';

      // console.log(documentItem);
      if (documentItem.search_type && documentItem.search_type.length > 0 && documentItem.search_type[0] === 'USERNOTE') {
        tempChannel = 'Note';
      }

      if (
        documentItem.search_type &&
        documentItem.search_type.length > 0 &&
        documentItem.search_type[0] === 'FILE' &&
        (documentItem.path?.includes('opt/deepsignal/download') ||
          (documentItem.path?.includes('UID_') &&
            documentItem.path?.includes('T') &&
            documentItem.path?.includes('Z_') &&
            documentItem.path?.includes('.')))
      ) {
        tempChannel = 'File';
      }

      if (tempChannel === null || tempChannel === undefined) {
        tempChannel = '';
      }
    }

    return tempChannel;
  }
}
